{
  "enum": {
    "IxcDtccDrecoV1AssetStatus": {
      "ACTIVE": "Active",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "IxcDtccDrecoV1AssetQueryServiceAssetListFilterableFields": {
      "assetId": "Asset",
      "cusip": "CUSIP",
      "data": {
        "security": {
          "cusip": "Security CUSIP"
        }
      },
      "status": "Status"
    }
  },
  "oneOf": {
    "IxcDtccDrecoV1AssetEventType": {
      "assetInfo": "Asset Info",
      "dayOpened": "Day Opened",
      "openDay": "Open Day"
    }
  },
  "searchEnum": {
    "IxcDtccDrecoV1AssetQueryServiceAssetListSearchableFields": {
      "data": {
        "security": {
          "name": "Security Name",
          "symbol": {
            "base": "Security Symbol Base"
          }
        }
      }
    }
  },
  "sortEnum": {
    "IxcDtccDrecoV1AssetQueryServiceAssetListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}